import React from 'react'

import cls from './TextField.module.scss'
import { classNames } from '@/shared/lib/utils/classNames'

export const TextField = ({ placeholder, value, setValue, className, withValidation, valid }) => {
    return (
        <input
            placeholder={placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className={classNames(cls.TextField, [className], {
                [cls.invalid]: withValidation && !valid,
            })}
        />
    )
}
